import React, { SVGProps } from 'react';

export const TopAffiliateIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 30,
  height = 30,
  fill = '#0063D6',
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 30 30"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="14.5" cy="14.5" fill={fill} r="12.5" />
      <path
        clipRule="evenodd"
        d="M21.98 12.2535C21.602 11.2955 21.0312 10.4254 20.303 9.69706C19.5749 8.96874 18.7049 8.39775 17.747 8.01949C17.5208 8.27625 17.3402 8.56982 17.213 8.88749C18.1086 9.21306 18.9219 9.73098 19.5957 10.4048C20.2695 11.0786 20.7874 11.8919 21.113 12.7875C21.4307 12.6603 21.7242 12.4797 21.981 12.2535M15.229 8.50349L15 8.50049C13.7047 8.50049 12.439 8.88748 11.3651 9.61182C10.2913 10.3362 9.45837 11.3648 8.9732 12.5658C8.48803 13.7668 8.37275 15.0854 8.64214 16.3523C8.91153 17.6193 9.55331 18.7769 10.4851 19.6766C11.417 20.5763 12.5964 21.1771 13.872 21.4019C15.1476 21.6266 16.4613 21.4652 17.6446 20.9382C18.8278 20.4112 19.8266 19.5427 20.5129 18.4441C21.1991 17.3455 21.5414 16.067 21.496 14.7725C21.84 14.6645 22.1653 14.5228 22.472 14.3475C22.49 14.5628 22.4993 14.7805 22.5 15.0005C22.4999 16.5117 22.0433 17.9876 21.19 19.2348C20.3367 20.4821 19.1266 21.4425 17.7181 21.9901C16.3097 22.5378 14.7686 22.6472 13.2969 22.3041C11.8252 21.9609 10.4915 21.1812 9.47049 20.067C8.44953 18.9528 7.78895 17.5563 7.57532 16.0602C7.36169 14.5642 7.60498 13.0386 8.27329 11.6832C8.94161 10.3278 10.0038 9.20592 11.3206 8.46455C12.6375 7.72319 14.1476 7.39691 15.653 7.52849C15.477 7.83777 15.3345 8.16496 15.228 8.50449"
        fill="#00224A"
        fillRule="evenodd"
      />
      <path
        d="M20 13C21.6569 13 23 11.6569 23 10C23 8.34315 21.6569 7 20 7C18.3431 7 17 8.34315 17 10C17 11.6569 18.3431 13 20 13Z"
        fill="#00224A"
      />
    </svg>
  );
};
